function initEmailPreferences() {
  const modal = document.querySelector('[data-email-preferences-modal]');
  if (!modal || !window.axios) return;

  const saveUrl = modal.dataset.emailPreferencesEndpoint;
  const saveButton = modal.querySelector('[data-email-preferences-action]');
  const buttonText = modal.querySelector('[data-email-preferences-action-label]');
  const cancelButton = modal.querySelector('[data-email-preferences-cancel]');
  const description = modal.querySelector('[data-email-preferences-intro]');
  const preferenceNote = modal.querySelector('[data-email-preferences-scope]');
  const loadingIcon = modal.querySelector('[data-email-preferences-spinner]');
  const screenReaderMessage = modal.querySelector('[data-email-preferences-status]');

  if (!saveButton || !buttonText || !cancelButton || !description || !preferenceNote) return;

  let isSubscribed = modal.dataset.emailPreferencesEnabled === 'true';

  const subscribedContent = {
    description: 'You can stop receiving optional campaign announcements and promotional updates at any time.',
    note: 'This preference will apply only to optional emails. It will not affect your account or active campaign participation.',
    action: 'Unsubscribe from optional emails',
    cancel: 'Keep emails',
  };

  const unsubscribedContent = {
    description: 'Optional campaign announcements and promotional updates are currently turned off.',
    note: 'You can turn optional emails back on at any time. Your account and active campaign participation are not affected.',
    action: 'Subscribe to optional emails',
    cancel: 'Close',
  };

  // Show the correct content for the user's current preference.
  function updateModalContent() {
    const content = isSubscribed ? subscribedContent : unsubscribedContent;

    description.textContent = content.description;
    preferenceNote.textContent = content.note;
    buttonText.textContent = content.action;
    cancelButton.textContent = content.cancel;
    modal.dataset.emailPreferencesEnabled = String(isSubscribed);
  }

  // Save the opposite of the current preference without refreshing the page.
  saveButton.addEventListener('click', async function () {
    if (!saveUrl || saveButton.disabled) return;

    saveButton.disabled = true;
    saveButton.setAttribute('aria-busy', 'true');
    loadingIcon?.classList.remove('d-none');

    try {
      const response = await window.axios.patch(saveUrl, {
        marketing_emails_enabled: !isSubscribed,
      });

      isSubscribed = response.data.marketing_emails_enabled;
      const message = response.data.message || 'Email preferences updated.';

      updateModalContent();
      if (screenReaderMessage) screenReaderMessage.textContent = message;
      window.toastr?.success(message);
    } catch (error) {
      const message = error?.response?.data?.message || 'Email preferences could not be updated. Please try again.';
      if (screenReaderMessage) screenReaderMessage.textContent = message;
      window.toastr?.error(message);
    } finally {
      saveButton.disabled = false;
      saveButton.setAttribute('aria-busy', 'false');
      loadingIcon?.classList.add('d-none');
    }
  });

  updateModalContent();
}

document.addEventListener('DOMContentLoaded', initEmailPreferences);
